import { fetchFile } from "../services/AiService";

const cache = new Map<number, Promise<string>>();

/** Object URL for a tenant-private file, fetched with the session token (cached for the page lifetime). */
export const secureFileUrl = (fileId: number): Promise<string> => {
  if (!cache.has(fileId)) {
    cache.set(
      fileId,
      fetchFile(fileId).then((blob) => URL.createObjectURL(blob)).catch((e) => {
        cache.delete(fileId);
        throw e;
      })
    );
  }
  return cache.get(fileId)!;
};

export const saveBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};

export const downloadSecureFile = async (fileId: number, fileName: string) => saveBlob(await fetchFile(fileId), fileName);

export const openSecureFile = async (fileId: number) => {
  const url = await secureFileUrl(fileId);
  window.open(url, "_blank", "noopener");
};
